import { call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';

export function* sprintInsuranceDeviceNavigate() {
  yield call(authenticateUser);
};

export function* bypassedInsuranceDeviceNavigate() {
  yield call(authenticateUser);
};

